/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
import React from 'react';
import { useTheme } from '@/providers/theme';
import '../vlinder.min.css';

import { Toaster } from 'react-hot-toast';

export const Accessories = () => {
  const theme = useTheme();

  return (
    <>
      <Toaster
        toastOptions={{
          className: '',
          duration: 8000,
          style: {
            borderLeft: `4px solid ${theme?.colors?.primary}`,
            padding: '16px',
            color: theme?.colors?.black,
            fontSize: 15,
            fontWeight: 'bolder',
          },
          success: {
            style: {
              borderColor: theme?.colors?.toastSuccess,
            },
          },
          error: {
            style: {
              borderColor: theme?.colors?.toastError,
            },
          },
        }}
      />
    </>
  );
};
